import {IRestService} from "./IRestService";
import {IUserService} from "./IUserService";

export class UserService implements IUserService {
	public constructor(private readonly restService: IRestService) {
	}

	public getAdminUsers(): Promise<any> {
		return this.restService.get(`users/admin`);
	}

	public createUser(payload: any): Promise<any> {
		return this.restService.post(`users/create`, payload);
	}

	public loginUser(email: string, password: string): Promise<any> {
		return this.restService.post(`auth`, {email, password});
	}

	public updateProfile(profileData: any): Promise<any> {
		return this.restService.put(`users/profile`, profileData);
	}

	public changePassword(passwordData: any): Promise<any> {
		return this.restService.put(`users/password`, passwordData);
	}
}
